import { BaseComponent } from '../../base-component';
import { trackEvent, trackView } from '@otto-ec/nexus-registry/pdp/tracking';

export class DetailsComponent extends BaseComponent {
    public rootSelector = '.js_pdp_details';

    public async onHtmlLoaded(): Promise<void> {
        if (!this.isPresent()) {
            return;
        }

        const expanderElement = this.getChildElement<HTMLOcExpanderV1Element>('.js_pdp_details__expander');
        expanderElement.addEventListener('oc-open', () => this.handleExpanderOpened());
        expanderElement.addEventListener('oc-close', () => this.handleExpanderClosed());

        this.performViewTracking(expanderElement);
    }

    private performViewTracking(expanderElement: HTMLOcExpanderV1Element): void {
        trackView({
            product_Details: [expanderElement.isCutOff ? 'foldable' : 'not_foldable'],
        });
    }

    private handleExpanderOpened(): void {
        trackEvent({
            product_Details: ['more'],
        });
    }

    private handleExpanderClosed(): void {
        trackEvent({
            product_Details: ['less'],
        });

        this.getRootElement().scrollIntoView();
    }
}
